module.exports = "/assets/8d6ac60101a06e9e9a83c7ddd3b79288.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ZI.png
// module id = 3182
// module chunks = 0